import {SVGIcon} from '@homeaway/react-svg';
import {FACEBOOK__24} from '@homeaway/svg-defs/lib/defs/FACEBOOK__24';
import {GOOGLE_PLUS__24} from '@homeaway/svg-defs/lib/defs/GOOGLE_PLUS__24';
import {INSTAGRAM__24} from '@homeaway/svg-defs/lib/defs/INSTAGRAM__24';
import {LINKEDIN__24} from '@homeaway/svg-defs/lib/defs/LINKEDIN__24';
import {PINTEREST__24} from '@homeaway/svg-defs/lib/defs/PINTEREST__24';
import {TUMBLR__24} from '@homeaway/svg-defs/lib/defs/TUMBLR__24';
import {TWITTER__24} from '@homeaway/svg-defs/lib/defs/TWITTER__24';
import {YOUTUBE__24} from '@homeaway/svg-defs/lib/defs/YOUTUBE__24';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';

import './Social.less';

const SOCIAL_MAP = {
    'facebook': FACEBOOK__24,
    'googleplus': GOOGLE_PLUS__24,
    'instagram': INSTAGRAM__24,
    'linkedin': LINKEDIN__24,
    'pinterest': PINTEREST__24,
    'tumblr': TUMBLR__24,
    'twitter': TWITTER__24,
    'youtube': YOUTUBE__24,
};

export class Social extends React.Component {
    static contextType = TrackingContext;

    static propTypes = {
        className: PropTypes.string,
        data: PropTypes.arrayOf(PropTypes.shape({
            link: PropTypes.string,
            text: PropTypes.string,
        })),
    };

    constructor(props, context) {
        super(props, context);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(text) {
        return () => {
            const field = {
                actionlocation: `footer.${text.replace(/\s/g, '').toLowerCase()}`
            };
            this.context.trigger('footer.link.click', field);
        };
    }

    render() {
        const data = this.props.data;
        if (!data) {
            return null;
        }
        const className = classNames(
            'SiteFooterSocial hidden-xs',
            this.props.className,
        );
        return (
            <div className={className}>
                <div className="SiteFooterSocial__links">{data.map(({link, text}, index) => (
                    <a
                        aria-label={text}
                        className={'SiteFooterSocial__link'}
                        href={link}
                        key={index}
                        target="_blank"
                        title={text}
                        onClick={this.handleClick(text)}
                    ><SVGIcon inline markup={SOCIAL_MAP[text]}/></a>
                ))}</div>
            </div>
        );
    }
}

export default Social;
